import { createAsyncThunk } from '@reduxjs/toolkit';
import RootState from "../states/root.state";
import { getMyNotifications, getNotifications, getNotificationById, createNotificationApi, updateNotificationApi, deleteNotificationApi } from '../../services/api/notifications.api';

export const fetchMyNotifications = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
  'notifications/my',
  async (params, {rejectWithValue, getState}) => {
    try {
        const {user} = getState();
        const token = user.accessToken;
        const response = await getMyNotifications(token, params);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data?.data?.message??error.response.data?.message??"An error occurred while fetching notifications.");
        } else {
            return rejectWithValue('An error occurred while fetching notifications.');
        }
    }
  }
);

export const fetchNotifications = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
  'notifications/list',
  async (params, {rejectWithValue, getState}) => {
    try {
        const {user} = getState();
        const token = user.accessToken;
        const response = await getNotifications(token, params);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data?.data?.message??error.response.data?.message??"An error occurred while fetching notifications.");
        } else {
            return rejectWithValue('An error occurred while fetching notifications.');
        }
    }
  }
);

export const fetchNotificationById = createAsyncThunk<any, number, { rejectValue: string; state: RootState}>(
  'notifications/show',
  async (id, {rejectWithValue, getState}) => {
    try {
        const {user} = getState();
        const token = user.accessToken;
        const response = await getNotificationById(token, id);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data?.data?.message??error.response.data?.message??"An error occurred while fetching notification.");
        } else {
            return rejectWithValue('An error occurred while fetching notification.');
        }
    }
  }
);

export const createNotification = createAsyncThunk<any, {
  title: string,
  text: string,
  image_key?: string | null,
  scheduled_at?: string | null,
  action?: any,
  url?: string | null,
  platform?: string[] | null,
  dealer_ids?: number[],
  user_ids?: number[] | null,
}, { rejectValue: string; state: RootState}>(
  'notifications/create',
  async (notifInfo, {rejectWithValue, getState}) => {
    try {
        const {user} = getState();
        const token = user.accessToken;
        const response = await createNotificationApi(token, notifInfo);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data?.data?.message??error.response.data?.message??"An error occurred while creating notification.");
        } else {
            return rejectWithValue('An error occurred while creating notification.');
        }
    }
  }
);

export const updateNotification = createAsyncThunk<any, {id: number, data: any}, { rejectValue: string; state: RootState}>(
  'notifications/update',
  async ({id, data}, {rejectWithValue, getState}) => {
    try {
        const {user} = getState();
        const token = user.accessToken;
        const response = await updateNotificationApi(token, id, data);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data?.data?.message??error.response.data?.message??"An error occurred while updating notification.");
        } else {
            return rejectWithValue('An error occurred while updating notification.');
        }
    }
  }
);

export const deleteNotification = createAsyncThunk<any, number, { rejectValue: string; state: RootState}>(
  'notifications/delete',
  async (id, {rejectWithValue, getState}) => {
    try {
        const {user} = getState();
        const token = user.accessToken;
        await deleteNotificationApi(token, id);
        return id;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data?.data?.message??error.response.data?.message??"An error occurred while deleting notification.");
        } else {
            return rejectWithValue('An error occurred while deleting notification.');
        }
    }
  }
);
